import { useQuery } from '@tanstack/react-query';

import { getCartPrice } from '../../api/bookings';
import { BookingMode } from '../../api/search';

export function useCampCartPriceInfoQuery(campId: number, childIds: number[]) {
  const { data: cartPricingInfo = null } = useCampPriceQuery(campId, childIds);
  const totalPrice = Number(cartPricingInfo?.total);
  return {
    cartPricingInfo,
    totalPrice,
  };
}

function useCampPriceQuery(campId: number, childIds: number[]) {
  return useQuery({
    queryKey: ['price', campId, childIds],
    queryFn: () =>
      getCartPrice('camp', undefined, childIds, campId).then((res) =>
        res.ok ? res.body : null
      ),
  });
}

export function useBookingCartPriceQuery({
  bookingMode,
  childIds,
  slotIds,
}: {
  bookingMode: BookingMode | null;
  childIds: number[];
  slotIds: number[];
}) {
  return useQuery({
    enabled: !!bookingMode,
    queryKey: ['cartPrice', bookingMode, childIds, slotIds],
    queryFn: () =>
      slotIds.length > 0 && childIds.length > 0 && bookingMode
        ? getCartPrice(bookingMode, slotIds, childIds).then((res) =>
            res.ok ? res.body : null
          )
        : null,
  });
}
